var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { styled } from '@mui/system';
import { getAttributes } from '../../../../../utils';
import { RatingAndReviewsTypes } from './types';
var MuiRatingAndReviews = styled('div', {
    name: 'MuiRatingAndReviews',
    overridesResolver: function (wrapperProps, styles) { return [styles.root]; }
})({});
var RAR = function (_a) {
    var props = __rest(_a, []);
    var type = props.type, productId = props.productId, rest = __rest(props, ["type", "productId"]);
    var typeMapped = 'inline_rating';
    var className;
    switch (type) {
        case RatingAndReviewsTypes.Reviews:
            typeMapped = 'reviews';
            className = 'reviews';
            break;
        case RatingAndReviewsTypes.RatingSummary:
            typeMapped = 'rating_summary';
            className = 'rating-summary';
            break;
        case RatingAndReviewsTypes.InlineRating:
        default:
            typeMapped = 'inline_rating';
            className = 'rating-inline';
            break;
    }
    var containerConfig = __assign(__assign({ className: className, 'data-bv-show': typeMapped, 'data-bv-product-id': productId }, (typeMapped === RatingAndReviewsTypes.Reviews && {
        'data-bv-seo': false
    })), getAttributes(rest));
    return productId ? React.createElement(MuiRatingAndReviews, __assign({}, containerConfig)) : null;
};
export { RAR as RatingAndReviews };
